// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../microservices/playlist/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tooltip.playposit-tooltip{display:none}", ""]);
// Exports
module.exports = exports;
